"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const MappingCanvasLoader_1 = require("./MappingCanvasLoader");
const ReadyView_1 = require("./ReadyView");
exports.MappingCanvas = () => {
    const defaultPreferences = {
        codeMode: false,
        codeModeSize: 'sm',
        view: 'EMAIL_MAKER_DEFAULT_VIEW_ID',
    };
    return (react_2.default.createElement(react_1.OsmosysCanvasPage, { defaultPrefs: defaultPreferences, onQueryChange: ({ meta, prefs, state, canvasQueries }) => {
            const contentMapping = canvasQueries &&
                canvasQueries.contentMapping &&
                canvasQueries.contentMapping.result &&
                canvasQueries.contentMapping.result.data &&
                canvasQueries.contentMapping.result.data.contentMapping;
            return {
                meta,
                prefs,
                ready: !!contentMapping,
                state: Object.assign(Object.assign({}, state), { draft: contentMapping, source: contentMapping }),
            };
        } },
        react_2.default.createElement(MappingCanvasLoader_1.MappingCanvasLoader, null),
        react_2.default.createElement(react_1.OsmosysCanvasPageReadyState, null,
            react_2.default.createElement(ReadyView_1.MappingCanvasReadyView, null)),
        react_2.default.createElement(react_1.OsmosysCanvasPageLoadingState, null),
        react_2.default.createElement(react_1.OsmosysCanvasPageUndesiredState, null)));
};
exports.default = exports.MappingCanvas;
//# sourceMappingURL=index.js.map